"use client";

import { PriceCalculator } from "@/components/shared/public";
import type { PricingConfig } from "@/lib/pricing";
import { useTranslations } from "next-intl";

type PriceCalculationProps = {
  pricingConfig: PricingConfig;
};

const PriceCalculation = ({ pricingConfig }: PriceCalculationProps) => {
  const t = useTranslations("common");

  return (
    <PriceCalculator
      orderHref="/user/order-sales-optimized-floor-plan"
      freeOptions={[
        { name: "furniture", label: t("furnishings") },
        { name: "north_arrow", label: t("northArrow") },
        { name: "room_names", label: t("roomNames") },
        { name: "entrance_arrow", label: t("entranceArrow") },
        { name: "watermark", label: t("watermark") },
        { name: "sqm_each_room", label: t("squareMetersPerRoom") },
        { name: "kitchen", label: t("kitchenEquipment") },
        { name: "scale", label: t("scale") },
        { name: "bathroom_equipment", label: t("bathroomEquipment") },
      ]}
      paidOptions={[
        { label: t("dimensionalChain"), name: "dimensional_chain" },
        {
          label: t("threeSixtyCreation"),
          name: "360_as_input",
        },
        { label: t("dwgFile"), name: "dwg_file" },
        { label: t("locationMap"), name: "area_map" },
      ]}
      pricingConfig={pricingConfig}
      id={"section-3"}
    />
  );
};

export default PriceCalculation;
